import { withDependencies } from '@wix/thunderbolt-ioc'
import { uiContextProviders, providerApiFactories } from '@wix/external-component-renderer'

export type UiLibProviders = {
	name: string
	wrapProviders: (comp: React.ComponentType<any>) => React.ComponentType<any>
}
export const ExternalComponentUiLibProviders = withDependencies(
	[],
	(): UiLibProviders => {
		return {
			name: 'externalComponentUiLibProviders',
			wrapProviders: (comp) => {
				const { wrapProviders } = uiContextProviders<'mui'>(['mui'], providerApiFactories)
				return wrapProviders(comp)
			},
		}
	}
)
